/* eslint-disable object-curly-newline */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { Container, Button } from "react-bootstrap";
import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";
import { AvForm } from "availity-reactstrap-validation";

import { fetchReferrals } from "store/client/actions";
import { fetchAgreements, showSuccessNotification } from "store/actions";

import RecursiveTableRows from "./RecursiveTableRows";
import Select from "react-select";
import { fetchMamProfiles } from "store/mam-pam/actions";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { cpUrl } from "content";
import { profiles as allocationTypes } from "common/mam-pamm";
import CustomSelect from "components/Common/CustomSelect";
import * as XLSX from "xlsx";

const Referral = ({ t }) => {
  const dispatch = useDispatch();

  const { _id, referrals, fx } = useSelector(
    (state) => state.clientReducer?.clientDetails
  );
  const { agreements } = useSelector((state) => state.ibAgreements);
  const { profiles, loading } = useSelector((state) => ({
    profiles: state.mamPamReducer.profile?.profiles,
    loading: state.mamPamReducer.profile?.loading,
  }));

  const [selectedAgreement, setSelectedAgreement] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedReferral, setSelectedReferral] = useState(null);
  const allocationType = allocationTypes.find((item) => item.value === selectedProfile?.profileType)?.label ?? "-";

  const parentFirstName = referrals?.[0]?.firstName;
  const parentLastName = referrals?.[0]?.lastName;

  const filteredReferrals = selectedAgreement ?
    referrals?.[0]?.childs?.filter(referral => ((referral.fx.agrementId === selectedAgreement) || referral.fx.agrementId === undefined)) :
    referrals?.[0]?.childs;
  
  const childData = [];
  
  (filteredReferrals || []).forEach(child => {
    const data = getChildData(child, parentFirstName, parentLastName, 0);
    childData.push(data);
  });
  
  function getChildData(child, parentFirstName, parentLastName, level) {
    const data = {
      "Name": `${child?.firstName || ""} ${child?.lastName || ""}`,
      "Email": child?.email || "",
      "Parent Name": `${parentFirstName || ""} ${parentLastName || ""}`,
      "Client Type": child?.fx?.isIb ? "Sub IB" : "Client",
      "Live Accounts": child?.fx?.liveAcc?.length > 0 ? child?.fx?.liveAcc.join(", ") : "No Accounts",
      "Demo Accounts": child?.fx?.demoAcc?.length > 0 ? child?.fx?.demoAcc.join(", ") : "No Accounts",
      "Indentation Level": level
    };
  
    if (child.childs && child.childs.length > 0) {
      data["Childs"] = child.childs.map(subchild => getChildData(subchild, child.firstName, child.lastName, level + 1)); // Increase indentation level for nested child
    }
  
    return data;
  }
  
  const downloadRefferalsExcel = () => {
    const nestedChildData = [];
    
    nestedChildData.push([
      "Name",
      "Email",
      "Parent Name",
      "Client Type",
      "Live Accounts",
      "Demo Accounts"
    ]);
    
    function populateNestedChildData(data) {
      const index = nestedChildData.length - 1;
      const insertIndex = index < 0 ? 0 : index + 1; 
      
      nestedChildData.splice(insertIndex, 0, [
        ...Array(data["Indentation Level"]).fill(""),
        data.Name,
        data.Email,
        data["Parent Name"],
        data["Client Type"],
        data["Live Accounts"],
        data["Demo Accounts"]
      ]);
      
      if (data["Childs"]) {
        data["Childs"].forEach(child => populateNestedChildData(child));
        
        nestedChildData.splice(insertIndex + 1, 0, [
          ...Array(data["Indentation Level"]).fill(""),
          "Child",
          "Name",
          "Email",
          "Parent Name",
          "Client Type",
          "Live Accounts",
          "Demo Accounts"
        ]);
      }
    }
    
    childData.forEach(child => populateNestedChildData(child));
  
    const ws = XLSX.utils.aoa_to_sheet([[]]);
    ws["!cols"] = [{ width: 10 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }];
    XLSX.utils.sheet_add_aoa(ws, nestedChildData, { origin: "A2" });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "referrals.xlsx");
  };

  const profileData = [{
    "Profile Type": allocationType,
    "Master Login": selectedProfile?.masterTradingAccountId?.login,
    "Fee Login": selectedProfile?.feeTradingAccountId?.login,
    "Members": selectedProfile?.slaves?.length,
    "Dedicated Link": `${cpUrl}/register/forex/investor?spRef=${selectedProfile?.recordId}`,
  }];

  const downloadProfileExcel = () => {
    const ws = XLSX.utils.json_to_sheet(profileData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "profile.xlsx");
  };

  useEffect(() => {
    if (_id) {
      _id &&
        dispatch(
          fetchReferrals({
            type: "live",
            clientId: _id,
          })
        );
      dispatch(fetchAgreements({ customerId: _id }));
      dispatch(fetchMamProfiles({
        customerId: _id,
        page: 1,
        limit: 100,
      }));
    }
  }, [_id]);

  const renderBody = (type) => {
    if (type === "IB") {
      return (
        <Table className="table table-hover text-center">
          <Thead>
            <Tr>
              <Th className="py-2 text-start">{t("Name")}</Th>
              <Th className="py-2 text-start">{t("Email Address")}</Th>
              <Th className="py-2 text-start">{t("Parent Name")}</Th>
              <Th className="py-2">{t("Client Type")}</Th>
              <Th className="py-2">{t("Accounts")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            <RecursiveTableRows
              data={referrals[0]}
              filter={selectedAgreement}
              level={0}
            />
          </Tbody>
        </Table>
      );
    } else if (type === "SP" && selectedProfile?.recordId) {
      return (
        <>
          <Table className="table table-hover text-center">
            <Thead>
              <Tr>
                <Th className="py-2 text-start">{t("Profile Type")}</Th>
                <Th className="py-2 text-start">{t("Master Login")}</Th>
                <Th className="py-2">{t("Fee Login")}</Th>
                <Th className="py-2">{t("Members")}</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Th className="py-2 text-start">{allocationType}</Th>
                <Th className="py-2 text-start">{selectedProfile?.masterTradingAccountId?.login}</Th>
                <Th className="py-2">{selectedProfile?.feeTradingAccountId?.login}</Th>
                <Th className="py-2">{selectedProfile?.slaves?.length}</Th>
              </Tr>
            </Tbody>
          </Table>
          <Card>
            <CardHeader className="py-3">
              <CardTitle className="mb-0">{t("Dedicated Link")}</CardTitle>
            </CardHeader>
            <CardBody>
              <Link to="#"
                className="mdi mdi-clipboard-check-multiple-outline font-size-20 me-2"
                onClick={() => {
                  navigator.clipboard.writeText(`${cpUrl}/register/forex/investor?spRef=${selectedProfile?.recordId}`);
                  dispatch(showSuccessNotification("Link copied to clipboard"));
                }}
              ></Link>
              {`${cpUrl}/register/forex/investor?spRef=${selectedProfile?.recordId}`}
            </CardBody>
          </Card>
        </>
      );
    }
  };

  return (
    <Container fluid className="gx-4" style={{
      minHeight: "60vh",
    }}>
      <AvForm className="d-flex">
        <div className="row m-2">
          <label>{t("Referrals For")}</label>
          <CustomSelect
            className="w-full"
            name="referral"
            onChange={(e) => {
              setSelectedReferral(e.value);
            }}
            value={selectedReferral === null ? "" : undefined}
            options={
              (()=>{
                const options = [];
                if (fx?.isIb) {
                  options.push({
                    label: "IB",
                    value: "IB",
                  });
                }
                if (fx?.isSp) {
                  options.push({
                    label: "Signal Provider",
                    value:"SP",
                  });
                }
                return options;
              })()
            }
          />
        </div>
        {
          selectedReferral === "IB" && <>
            <div className="row m-2">
              <label>{t("Select Agreement")}</label>
              <Select
                className="w-full"
                name="agreement"
                onChange={(e) => {
                  setSelectedAgreement(e.value);
                }}
                value={selectedAgreement === null ? "" : undefined}
                options={agreements?.map((agreement) => {
                  return {
                    label: agreement.title,
                    value: agreement._id,
                  };
                })}
              />
            </div>
          </>
        }
        {
          selectedReferral === "SP" && <>
            <div className="row m-2">
              <label>{t("Select Profile")}</label>
              <CustomSelect
                className="w-full"
                name="profile"
                onChange={(e) => {
                  setSelectedProfile(e.value);
                }}
                value={selectedProfile &&  {
                  label: `${selectedProfile.profileType} | ${selectedProfile.masterTradingAccountId?.login} | ${selectedProfile.slaves?.length} Members`,
                  value: selectedProfile,
                }}
                options={profiles?.map((profile) => {
                  return {
                    label: `${profile.profileType} | ${profile.masterTradingAccountId?.login} | ${profile.slaves?.length} Members`,
                    value: profile,
                  };
                })}
              />
            </div>
          </>
        }
        <div className="row col-md-auto align-content-end m-2">
          <Button
            onClick={() => {
              setSelectedAgreement(null);
              setSelectedReferral(null);
              setSelectedProfile(null);
            }}
          >
            {t("Clear")}
          </Button>
        </div>
        {selectedReferral === "IB" && 
          <div className="row col-md-auto align-content-end" style={{margin : "0.5rem 0 0.5rem auto"}}>
            <Button onClick={downloadRefferalsExcel}>Download Referrals</Button>
          </div>
        }
        {selectedReferral === "SP" && 
          <div className="row col-md-auto align-content-end" style={{margin : "0.5rem 0 0.5rem auto"}}>
            <Button disabled={!selectedProfile} onClick={downloadProfileExcel}>Download Profile</Button>
          </div>
        }
      </AvForm>
      {selectedReferral && (referrals?.length > 0 || selectedProfile !== null) && <Card className="p-4 m-2">
        {renderBody(selectedReferral)}
      </Card>}
    </Container>
  );
};

export default withTranslation()(Referral);
